import { themeColors } from "../../config.js";
export const windowStyle = {
  panel: {
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    height: 25,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    backgroundColor: themeColors.optionColor,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  },
  title: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: 10,
    color: themeColors.optionTextColor,
    fontFamily: "roboto",
    whiteSpace: "nowrap",
    cursor: "grab",
    overflow: "hidden",
  },
  controlBtn: {
    margin: 2,
    height: 16,
    width: 16,
    borderRadius: 8,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  content: {
    position: "absolute",
    top: 25,
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    flex: 1,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    overflow: "auto",
  },
};
